import axios from 'axios';
import keycloak from '../config/keycloak';

const backedUrl = new URL(process.env.REACT_APP_BACKEND_URL || '');

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

axiosInstance.interceptors.request.use((request) => {
  const requestUrl = new URL(request.baseURL || '' + request.url || '');
  if (backedUrl.host === requestUrl.host && !request.headers.get('Authorization'))
    request.headers.set('Authorization', 'Bearer ' + keycloak.token);

  return request;
});

export default axiosInstance;
